var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13647_12089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.61341 8.82474C1.52262 8.68098 1.47723 8.6091 1.45182 8.49823C1.43273 8.41495 1.43273 8.28362 1.45182 8.20034C1.47723 8.08947 1.52262 8.01759 1.61341 7.87383C2.36365 6.68584 4.59682 3.68262 8.00004 3.68262C11.4033 3.68262 13.6364 6.68584 14.3867 7.87383C14.4775 8.01759 14.5228 8.08947 14.5483 8.20034C14.5673 8.28362 14.5673 8.41495 14.5483 8.49823C14.5228 8.6091 14.4775 8.68098 14.3867 8.82474C13.6364 10.0127 11.4033 13.016 8.00004 13.016C4.59682 13.016 2.36365 10.0127 1.61341 8.82474Z",
    stroke: "#A39992",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 10.3493C9.10457 10.3493 9.99997 9.45385 9.99997 8.34928C9.99997 7.24471 9.10457 6.34928 8.00004 6.34928C6.89551 6.34928 6.00011 7.24471 6.00011 8.34928C6.00011 9.45385 6.89551 10.3493 8.00004 10.3493Z",
    stroke: "#A39992",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13647_12089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9994,
    height: 16,
    fill: "white",
    transform: "translate(0 0.349609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.55705aba923b3b93f8239dbd684c01d1.svg";
export { ForwardRef as ReactComponent };